import { render, staticRenderFns } from "./editPet.vue?vue&type=template&id=46b5e5a7"
import script from "./editPet.vue?vue&type=script&lang=js"
export * from "./editPet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports